import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M8.057 21.35a2 2 0 01-2.78-2.02l.388-4.272-2.824-3.228a2 2 0 011.061-3.267l4.183-.952 2.197-3.684a2 2 0 013.436 0l2.197 3.684 4.183.952a2 2 0 011.061 3.267l-2.824 3.228.387 4.272a2 2 0 01-2.779 2.02L12 19.66l-3.943 1.69z" fill="currentColor" /></svg>);